import { FC, memo } from 'react';
import { Toggle } from '@bizzabo/design-system';
import { useHideProfileExplanationTooltip, useHideProfileToggle } from 'people/UserProfile/hooks';

type HideProfileToggleProps = {
    eventId: number;
    userProfileId: number;
    isHidden: boolean;
};

const HideProfileToggle: FC<HideProfileToggleProps> = ({ eventId, userProfileId, isHidden }) => {
    const tooltipText = useHideProfileExplanationTooltip();
    const changeIsProfileHidden = useHideProfileToggle(eventId, userProfileId);

    const hideProfileLabel = isHidden ? 'Unhide my profile' : 'Hide my profile';

    const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        changeIsProfileHidden(event.target.checked);
    };

    return (
        <Toggle
            label={hideProfileLabel}
            checked={isHidden}
            onChange={handleOnChange}
            showTooltip
            tooltipText={tooltipText}
        />
    );
};

export default memo(HideProfileToggle);
